import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { LangText } from '@/components'
import { preFixImgUrl } from '@/utils'
import { Form, Button, message } from 'antd'
import CarRentalForm from './Forms/CarRentalForm'
import CharterForm from './Forms/CharterForm'
import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'
import { apiBookCar, type BookCarRequest } from '@/service/api/bookCar'
import dayjs from 'dayjs'
import { ConfigProvider } from 'antd';


const CarRentalReserve = () => {
  const { t } = useTranslation();
  const [type, setType] = useState<'rental' | 'charter'>('rental')
  const navigate = useNavigate()
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (values: any) => {
    try {
      setLoading(true)

      // 构建请求数据
      const requestData: BookCarRequest = {
        bookCarType: type,
        // 个人信息字段映射
        personalInfo: {
          name: values.name,
          phone: values.phone,
          email: values.email,
        },
        // 取车信息字段映射
        pickupInfo: {
          pickupDate: values.pickupDate ? dayjs(values.pickupDate).format('YYYY-MM-DD') : undefined,
          pickupTime: values.pickupTime ? dayjs(values.pickupTime).format('HH:mm') : undefined,
          pickupLocation: values.pickupLocation,
        },
        // 车辆需求字段映射
        carRequirementInfo: {
          carType: values.carType,
          passengerCount: values.passengerCount,
          luggageCount: values.luggageCount ?? undefined,
          specialRequirement: values.specialRequirement || undefined,
        },
      }

      // 租车类型需要还车信息
      if (type === 'rental') {
        requestData.returnInfo = {
          returnDate: values.returnDate ? dayjs(values.returnDate).format('YYYY-MM-DD') : undefined,
          returnTime: values.returnTime ? dayjs(values.returnTime).format('HH:mm') : undefined,
          returnLocation: values.returnLocation,
        }
      }

      // 包车类型需要送客信息
      if (type === 'charter') {
        requestData.dropoffInfo = {
          dropoffLocation: values.dropoffLocation,
          estimatedDistance: values.estimatedDistance != null ? String(values.estimatedDistance) : undefined,
          estimatedDuration: values.estimatedDuration != null ? String(values.estimatedDuration) : undefined,
        }
      }

      const res = await apiBookCar(requestData)

      if (res.code === 0) {
        message.success(t('e8e628a5'))
        // 提交成功后可以跳转或重置表单
        form.resetFields()
        navigate(-1);
      } else {
        message.error(res.msg)
      }
    } catch (error: any) {
    } finally {
      setLoading(false)
    }
  }

  const buttons = (<div className='flex items-center justify-center sticky bottom-0 -my-6 py-6 bg-[#EFF8EC]'>
    <Button
      type='primary'
      className='!h-[85px] flex-1 !rounded-[14px] !bg-[#59C55F]'
      htmlType='submit'
      loading={loading}
    >
      <LangText lngKey='faef94ae' className='text-[28px] text-white font-bold'>{t('faef94ae')}</LangText>
    </Button>
    <Button
      size='large'
      className='!h-[85px] ml-[50px] w-[257px] !rounded-[14px] !border-none'
      onClick={() => navigate(-1)}
    >
      <LangText lngKey='f26388d0' className='text-[28px] text-black font-bold'/>
    </Button>
  </div>)


  return (
    <ConfigProvider theme={{ token: { colorPrimary: '#59C55F' } }}>
      <div className='bg-[#EFF8EC]'>
        <div className='w-8xl mx-auto px-10 '>
          <div className='flex items-center pt-[80px] cursor-pointer' onClick={() => navigate(-1)}>
            <div className='w-[24px] h-[24px] rounded-[50%] flex items-center justify-center shrink-0 mr-2 bg-[#59C55F]'>
              <img src={preFixImgUrl('05491d4594559333f5a85785936f630b.png')} />
            </div>
            <LangText className='text-[24px]' lngKey='51109327'>{t('51109327')}</LangText>
          </div>
          <div className='mt-10 flex flex-col items-center'>
            <LangText className='text-[60px] font-bold text-black' lngKey='ff57f0d5'>{t('ff57f0d5')}</LangText>
            <LangText className='text-[30px] text-[#666666] mt-7' lngKey='9d8deb02'>{t('9d8deb02')}</LangText>
          </div>
          <div className='flex gap-4 mt-[92px] mb-[50px]'>
            <div className={classNames('group flex rounded-[20px] px-[22px] h-[152px] items-center flex-1 cursor-pointer', {
              'bg-transparent': type !== 'rental',
              'bg-[#59C55F]': type === 'rental',
              'outline outline-[#81A183]': type !== 'rental',
            })} onClick={() => setType('rental')}>
              <div className='w-[67px] h-[67px] flex items-center justify-center shrink-0  mr-6 bg-[#29A730] rounded-[14px]'>
                <img className='w-[80%]' src={preFixImgUrl('5567294e5dd274c32061bd674be17fc0.png')} />
              </div>
              <div className={classNames('flex flex-col', {
                'text-white': type === 'rental',
              })}>
                <LangText lngKey='d3e350d1' className='text-[30px] font-bold'>{t('d3e350d1')}</LangText>
                <LangText lngKey='76d4e820' className='text-[18px] mt-[18px]'>{t('76d4e820')}</LangText>
              </div>
            </div>
            <div className={classNames('group flex rounded-[20px] px-[22px] h-[152px] items-center flex-1 cursor-pointer', {
              'bg-transparent': type !== 'charter',
              'bg-[#59C55F]': type === 'charter',
              'outline outline-[#81A183]': type !== 'charter',
            })} onClick={() => setType('charter')}>
              <div className='w-[67px] h-[67px] flex items-center justify-center shrink-0  mr-6 bg-[#29A730] rounded-[14px]'>
                <img className='w-[80%]' src={preFixImgUrl('0b4518979900b7f04f9d97eca03e468d.png')} />
              </div>
              <div className={classNames('flex flex-col', {
                'text-white': type === 'charter',
              })}>
                <LangText lngKey='b8b5f271' className='text-[30px] font-bold'>{t('b8b5f271')}</LangText>
                <LangText lngKey='d1d7609e' className='text-[18px] mt-[18px]'>{t('d1d7609e')}</LangText>
              </div>
            </div>
          </div>
          <Form form={form} layout='vertical' onFinish={handleSubmit} scrollToFirstError={{ focus: true, behavior: 'smooth' }}>
            {
              type === 'rental' && <CarRentalForm form={form}>{buttons}</CarRentalForm>
            }
            {
              type === 'charter' && <CharterForm>{buttons}</CharterForm>
            }
          </Form>
        </div>
      </div>
    </ConfigProvider>


  )
}

export default CarRentalReserve